export default "__VITE_ASSET__nMdbcQwY__"